import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

import { localCurrency } from "@/plugins/currency";
import { getMenuPriceByMenuId } from "@/plugins/subscriptions_helper";

@Component({
  methods: {
    localCurrency,
    getMenuPriceByMenuId,
  },
})
export default class SubscriptionMenusQuantities extends Vue {
  @Getter getSubscription;
  @Getter getMenus;
  @Getter getMenuPrices;

  getMenuById(menuId) {
    let response = null;
    if (this.getMenus && this.getMenus.length) {
      response = this.getMenus.find((menu) => menu.id === menuId);
    }
    return response;
  }
}
